<template>
  <div>

    <div class="px-8 pt-4">
      <div class="text-center py-2">
        <Logo></Logo>
      </div>
    </div>

    <div class="bg-radial py-0 md:py-0">
      <div class="md container mx-auto text-center p-8 md:max-w-md">
        <h1 class="text-white leading-normal text-center mb-4 font-semibold">Reference Documents</h1>
        <div class="text-white text-center flex justify-between">
          Information on our product and how we manage your personal and credit information when you apply for a
          SocietyOne personal loan.
        </div>
      </div>
    </div>

    <div class="bg-grey-lighter py-2">
      <div class="container max-w-sm mx-auto">
        <div class="container px-6 pt-6">
          <div class="mb-2">
            <h3 class="text-navy leading-tight">Privacy and Credit Reporting</h3>
          </div>
          <div class="mb-3 text-navy-light">
            Why we collect your personal and credit information and how we use it
          </div>
          <div class="mb-6 text-navy-light">
            <ul>
              <li class="mb-2"><a style="text-decoration:none;" class="text-blue cursor-pointer" target="_blank"
                                  href="https://docs.societyone.com.au/ASSETS/Privacy+Disclosure+Statement+and+Electronic+Communications+Consent.pdf">Privacy
                Disclosure Statement and <br> Electronics Communications Consent</a></li>
              <li class="mb-2"><a style="text-decoration:none;" class="text-blue cursor-pointer" target="_blank"
                                  href="https://www.societyone.com.au/legal#privacy-policy">Privacy Policy</a></li>
              <li class="mb-2"><a style="text-decoration:none;" class="text-blue cursor-pointer" target="_blank"
                                  href="https://content.societyone.com.au/policies/Credit+Guide.pdf">SocietyOne Credit
                Guide</a></li>
            </ul>
          </div>
        </div>
        <div class="container px-6 pb-6">
          <div class="mb-2">
            <h3 class="text-navy leading-tight mr-4">Direct Debit Terms &amp; Conditions</h3>
          </div>
          <div class="mb-3 text-navy-light">
            Using Direct Debit to make your loan repayments
          </div>
          <div class="text-navy-light">
            <ul class="">
              <li><a style="text-decoration:none;" class="text-blue cursor-pointer" target="_blank"
                     href="https://docs.societyone.com.au/ASSETS/Direct+Debit+Service+Agreement.pdf">Direct Debit
                Service Agreement</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <CustomerFooter></CustomerFooter>

  </div>
</template>

<script>
import Logo from '@/assets/Logo';
import CustomerFooter from '@/components/CustomerFooter';

export default {
  name: 'TomCTOPage',
  metaInfo: {
    title: 'Reference Documents | SocietyOne Personal Loans',
  },
  components: {Logo, CustomerFooter},
};
</script>

<style scoped>
.badge-position {
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/TomCTOPage.vue